(function($) {
    var _GMM_BUYSELECT_MATCHTRADE_ALL_VIEW_MODEL = {
        //接口数据
        goodsType: ko.observable(''),
        dianquan_thumbnail_url: ko.observable(''),
        price: ko.observable('0.000'),//当前均价
        selling_list: ko.observableArray([]),//卖出列表
        wantbuy_list: ko.observableArray([]),//买入列表
        init:function(){
            var self = this;
            self.GetTransactionIndexData();
            var list = $.getQueryStringByName("list");
            if (list == 'buy'){
                $('#sell-list').removeClass('active');
                $('#button-sell').removeClass('active');
                $('#buy-list').addClass('active');
                $('#button-buy').addClass('active');

            } else if (list == 'sell'){
                $('#buy-list').removeClass('active');
                $('#button-buy').removeClass('active');
                $('#sell-list').addClass('active');
                $('#button-sell').addClass('active');
            }         
            self.QueryBuyList();
            self.QuerySellList();
            self.getConfig();
        },  
        //数字转中文数字      
        NumberToChinese:function(num){
            function SectionToChinese(section){
              var strIns = '', chnStr = '';
              var unitPos = 0;
              var zero = true;
              while(section > 0){
                var v = section % 10;
                if(v === 0){
                  if(!zero){
                    zero = true;
                    chnStr = chnNumChar[v] + chnStr;
                  }
                }else{
                  zero = false;
                  if (unitPos == 1 && v == 1){//位数为十且十位数是1，即一十显示为十
                    strIns = '';                    
                  } else {
                    strIns = chnNumChar[v];
                  }                 

                  strIns += chnUnitChar[unitPos];
                  chnStr = strIns + chnStr;
                }
                unitPos++;
                section = Math.floor(section / 10);
              }
              return chnStr;
            }
            var chnNumChar = ["零","一","二","三","四","五","六","七","八","九"];
            var chnUnitSection = ["","万","亿","万亿","亿亿"];
            var chnUnitChar = ["","十","百","千"];
            var unitPos = 0;
            var strIns = '',
                chnStr = '';
            var needZero = false;

            if (num === 0) {
                return chnNumChar[0];
            }

            while (num > 0) {
                var section = num % 10000;
                if (needZero) {
                    chnStr = chnNumChar[0] + chnStr;
                }
                strIns = SectionToChinese(section);
                strIns += (section !== 0) ? chnUnitSection[unitPos] : chnUnitSection[0];
                chnStr = strIns + chnStr;
                needZero = (section < 1000) && (section > 0);
                num = Math.floor(num / 10000);
                unitPos++;
            }
            return chnStr;

        },
        getConfig:function(){
            var self = this;
            var url="/api/accountapi/config";
            var params={
                    method:"GetGameInfo",
                    params:JSON.stringify({
                        "game_id":791000218
                    })
                };
            $.ajaxBridgeCache(url,
                function(response){
                    if (response.return_code === 0){
                        var data = response.data;
                        self.dianquan_thumbnail_url(data.ext_info.dianquan_thumbnail_url);

                    }
                },
                params,"GET",false,0,
                function(response){
                    return $.BizReturnCodeCheck(response);
                },
                null
            );
        },
        sellTips:function(){
            $.toast('暂不支持，请在电脑上操作。');
        },
        QuerySellList:function(){
            var self = this;
            var url="/api/dianquanapi/order";
            var params={
                    method:"QuerySellingPriceStockList",
                    params:JSON.stringify({
                        "req_from":0,
                        "page":1,
                        "size":70,
                        "currency_id":3
                    })
                };
            $.ajaxBridgeCache(url,
                function(response){
                    if (response.return_code === 0){
                        var data = response.data;
                        self.selling_list(data.list);
                    }
                },
                params,"GET",false,0,
                function(response){
                    return $.BizReturnCodeCheck(response);
                },
                null
            );
        },
        QueryBuyList:function(){
            var self = this;
            var url="/api/dianquanapi/order";
            var params={
                    method:"QueryWantBuyPriceAmountList",
                    params:JSON.stringify({
                        "req_from":0,
                        "page":1,
                        "currency_id":3
                    })
                };
            $.ajaxBridgeCache(url,
                function(response){
                    if (response.return_code === 0){
                        var data = response.data;
                        self.wantbuy_list(data.list);
                    }
                },
                params,"GET",false,0,
                function(response){
                    return $.BizReturnCodeCheck(response);
                },
                null
            );
        },
        GetTransactionIndexData:function(){
            var self = this;
            var url="/api/dianquanapi/order";
            var params={
                    method:"GetTransactionIndexData",
                    params:JSON.stringify({
                        "req_from":0,
                        "currency_id":3
                    })
                };
            $.ajaxBridgeCache(url,
                function(response){
                    if (response.return_code === 0){
                        var data = response.data;
                        self.price(data.price);

                    }
                },
                params,"GET",false,0,
                function(response){
                    return $.BizReturnCodeCheck(response);
                },
                null
            );
        }
        
    };

    //页面入口函数
    $.PageReadyEntry_Matchtrade_All = function() {
        console.log("PageReadyEntry_Matchtrade_All");
        $.init();
        var koBindDom = $(".page-matchtrade-all")[0];
        var koBindFlag = $(koBindDom).attr("gmm-bind-flag");
        if (koBindFlag != "1") {
            ko.applyBindings(_GMM_BUYSELECT_MATCHTRADE_ALL_VIEW_MODEL, koBindDom);
            $(koBindDom).attr("gmm-bind-flag", "1");
        }
        _GMM_BUYSELECT_MATCHTRADE_ALL_VIEW_MODEL.init();
    };
})(Zepto)
